/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserStatDto } from '../../models/center-user-stat-dto';

export interface CenterUserControllerGetStat$Params {
  centerUserId: string;

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;
}

export function centerUserControllerGetStat(http: HttpClient, rootUrl: string, params: CenterUserControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserStatDto>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerGetStat.PATH, 'get');
  if (params) {
    rb.query('centerUserId', params.centerUserId, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserStatDto>;
    })
  );
}

centerUserControllerGetStat.PATH = '/api/center-user/stat';
